(function() { module.exports = this["ReactDOM"]; }());


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 4
// module chunks = 0